/**
 * TeamSystem Impact - Connessioni AI Page
 * Gestione token API e sistemi OAuth connessi.
 */

import { Box, Divider, Typography } from '@mui/material';
import { AgentTokenTab } from './components/AgentTokenTab';
import { OAuthClientList } from './components/OAuthClientList';

export function ConnectionsPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Connessioni AI
      </Typography>

      <AgentTokenTab />

      <Divider sx={{ my: 4 }} />

      <OAuthClientList />
    </Box>
  );
}
